import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Modal } from "@material-ui/core";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { useSnackbar } from "notistack";
import useLoader from "../../../hooks/useLoader";
import { CustomInputField } from "../../common/FormInputs";
import {
  PrimaryOutlinedCTAButton,
  PrimaryCTAButton,
} from "../../common/Buttons";
import { getErrorMessage } from "../../../helpers/functions";
import useBundle from "../../../hooks/useBundle";
import BundleService from "../../../services/BundleService";

export default function RefundModal({
  openBundleModal,
  setOpenBundleModal,
  id,
  setRefreshDetails,
  setSuccess,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [bundle, setBundle] = useState();
  const { setBundleOpen } = useBundle();
  const [error, setError] = useState("");

  const addBundleName = async (value) => {
    try {
      const payload = {
        bundleName: value,
      };
      setLoader({ state: true, message: `Uploading Bundle Name` });
      const res = await BundleService.addBundle(payload, id);
      if (res) {
        // enqueueSnackbar("Bundle Added Successfully", {
        //   variant: "success",
        // });
        setSuccess(true);
        setBundle("");
        setRefreshDetails(true);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpenBundleModal(false);
      setBundleOpen({ state: true, boolean: true });
    }
  };

  useEffect(() => {
    if (openBundleModal) {
      setBundle("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openBundleModal]);

  const handleChange = (event) => {
    const name = event.target.value;
    /* eslint-disable no-useless-escape */
    const regexPattern = /^[^\/\\=]+$/;
    if (regexPattern.test(name)) {
      setError(false);
    } else {
      //eslint-disable-next-line
      setError(
        `Bundle name should not contain slashes ("/") and equal signs ("=")`
      );
    }
    setBundle(name);
  };

  return (
    <Modal
      open={openBundleModal}
      onClose={() => setOpenBundleModal(false)}
      disableRestoreFocus={true}
    >
      <DrawerContainer role="presentation">
        <Container>
          <HeadingContainer>
            <Heading>Bundle Name</Heading>
            <CloseModal
              onClick={() => setOpenBundleModal(false)}
              src={require("../../../assets/images/closeModal.svg")}
            />
          </HeadingContainer>
          <AgentFormContainer>
            <Label>Enter Bundle Name</Label>
            <CustomInputField
              variant="outlined"
              error={!!error}
              helperText={error}
              required={true}
              onChange={(e) => handleChange(e)}
            />
            <ButtonContainer>
              <PrimaryOutlinedCTAButton
                style={{ width: "45%" }}
                onClick={() => setOpenBundleModal(false)}
              >
                Cancel
              </PrimaryOutlinedCTAButton>
              <PrimaryCTAButton
                style={{ width: "45%" }}
                onClick={() => addBundleName(bundle)}
                disabled={!bundle || error}
              >
                Submit
              </PrimaryCTAButton>
            </ButtonContainer>
          </AgentFormContainer>
        </Container>
      </DrawerContainer>
    </Modal>
  );
}

const Container = styled.div`
  margin: 0 15px;
  background-color: white;
  outline: none;
  border-radius: 8px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    max-width: 516px;
  }
`;

const HeadingContainer = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const Label = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12px;
  line-height: 1.7;
  color: ${COLORS.INPUT_LABEL};
  margin-bottom: 10px;
`;

const AgentFormContainer = styled.p`
  padding: 24px 15px 30px 15px;
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontRegular};
  line-height: 1.71;
  text-align: justify;
  min-height: 200px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 24px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-around;
`;

const CloseModal = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  right: 40px;
`;

const Heading = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontExtraBold};
`;
